// URLs
export const providerApiInternal = 'https://signup.providers.cebroker.com/api';
export const AUTH_URL = 'https://accounts.cebroker.com';
export const PROVIDER_SUITE_URL = 'https://providers.cebroker.com';
export const HOME_URL = 'https://cebroker.com';
export const LAUNCHPAD_URL = 'https://launchpad.cebroker.com';
export const REACT_APP_APM_SERVER_URL = 'https://c9b34aeaf1844e3ba4a4281022dff253.apm.us-east-1.aws.cloud.es.io:443';
// Export all
export default {
  providerApiInternal,
  AUTH_URL,
  PROVIDER_SUITE_URL,
  HOME_URL,
  LAUNCHPAD_URL,
  REACT_APP_APM_SERVER_URL,
};



// WEBPACK FOOTER //
// ./src/config/production.config.js